export default __webpack_public_path__ + "static/media/covid19.824007a0.gif";